import { computed, ref } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12c52de8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainComponent"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "head"
};
const _hoisted_4 = {
  class: "searchName"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "priceUpdate"
}, [/*#__PURE__*/_createElementVNode("span", null, "价格")], -1));
const _hoisted_6 = {
  class: "body"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据，等待输入默认价格", -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  class: "price"
};
const _hoisted_10 = {
  class: "currency"
};
const _hoisted_11 = {
  key: 0,
  class: "priceNum"
};
const _hoisted_12 = {
  key: 2,
  class: "iconBk"
};
const _hoisted_13 = {
  class: "extraInfo"
};
import SvgIcon from '@/components/SvgIcon.vue';
import { queryPriceList } from '@/api/goodsSetting';
// import useDetailHooks from '../hooks/useDetailHooks'
import { getLadderPrice } from '@/api/goodsInfo';
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceBlockConsume',
  props: {
    dbtId: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prodChnl: {
      type: String,
      default: ''
    },
    prodType: {
      type: String,
      default: ''
    },
    prodPriceCurrency: {
      type: String,
      default: ''
    },
    loading: {
      default: false,
      type: Boolean
    },
    areaList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['updateList', 'updateInputPrice'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    const prodChnlText = computed(() => {
      if (props.prodChnl === 'google') {
        return '*当前本地价格已采取谷歌定价模式';
      } else if (props.prodChnl === 'huawei' || props.prodChnl === 'huawei_foreign' || props.prodChnl === 'harmony') {
        return '*当前本地价格已采取华为定价模式';
      } else if (props.prodChnl === 'apple') {
        return '*请注意，未修改过本地价格的国家和地区，本地价格会随苹果汇率变化而自动变化';
      }
    });
    const searchMode = ref(false); // 开关过滤
    const queryPriceLoading = ref(false); // 加载效果
    const searchName = ref(''); // 绑定过滤搜索
    const showData = ref([]); // 经过筛选展示在下方的数据集
    const originData = ref([]); // 后端查询出来的数据集
    const showEdit = async (i, item) => {
      try {
        const res = await getLadderPrice({
          dbtId: props.dbtId,
          regionCode: item.regionCode,
          prodType: props.prodType
        });
        if (res.code === '0') {
          item.price = res.data;
        } else {
          item.price = [];
        }
      } catch (e) {
        item.price = [];
      }
    };
    const regroupData = dataArr => {
      if (!dataArr || (dataArr === null || dataArr === void 0 ? void 0 : dataArr.length) === 0) return [];
      let newArr = [];
      dataArr.map((item, ind) => {
        item['editMode'] = false;
        item['key'] = Math.random() * 10000 + '-' + ind;
        if (item.prodPrice !== item.originProdPrice) {
          newArr.unshift({
            ...item,
            price: []
          });
        } else {
          newArr.push({
            ...item,
            price: []
          });
        }
      });
      return newArr;
    };
    const queryData = async data => {
      if (!data.prodPrice) {
        originData.value = []; // 不输入默认价格，就查不到列表信息，所以置空
        showData.value = [];
      } else {
        queryPriceLoading.value = true;
        const res = await queryPriceList(data);
        queryPriceLoading.value = false;
        if (res.code === '0') {
          var _res$data;
          originData.value = regroupData((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.productNativePrice);
          originData.value = originData.value.filter(item => {
            return props.areaList.includes(item.regionName);
          });
          searcher();
        } else {
          originData.value = [];
          showData.value = [];
        }
      }
    }; // 查询价格信息
    const init = data => {
      originData.value = regroupData(data === null || data === void 0 ? void 0 : data.productNativePrice);
      originData.value = originData.value.filter(item => {
        return props.areaList.includes(item.regionName);
      });
      searcher();
    }; // 编辑回显数据
    const reset = () => {
      searchName.value = '';
      searchMode.value = false;
      queryPriceLoading.value = false;
      originData.value = [];
      showData.value = [];
    };
    // const askQuery = () => {
    //   emits('updateList')
    // }
    // const formatPrice = async (val: string, i: number) => {
    //   const flag = await verifyNumber({
    //     prodChnl: props.prodChnl,
    //     prodPrice: val,
    //     prodPriceCurrency: showData.value[i].prodPriceCurrency,
    //     regionCode: showData.value[i].regionCode,
    //     prodType: props.prodType,
    //   })
    //   if (!flag) {
    //     showData.value[i].prodPrice = showData.value[i].originProdPrice
    //   } else {
    //     showData.value[i].prodPrice = parseFloat(val).toFixed(2)
    //   }
    // }
    const confirmChange = (item, i) => {
      item.editMode = false;
      // 修改过后的内容要置顶
      if (item.prodPrice !== item.originProdPrice) {
        showData.value.splice(i, 1);
        showData.value.unshift(item);
      }
      emits('updateInputPrice');
    };
    const searcher = () => {
      showData.value = originData.value.filter(item => {
        if (searchName.value.trim()) {
          return item.regionName.includes(searchName.value);
        } else {
          return item;
        }
      });
      handleDataTop();
    }; // 数据搜索过滤
    const cancelData = item => {
      item.prodPrice = item.originProdPrice;
      item.editMode = false;
    }; // 取消数据修改
    const handleDataTop = () => {
      showData.value.forEach(item => {
        if (item.prodPrice !== item.originProdPrice) {
          showData.value.splice(showData.value.indexOf(item), 1);
          showData.value.unshift(item);
        }
      });
    }; // 修改过的数据置顶
    expose({
      init,
      queryData,
      regroupData,
      reset,
      showData,
      originData
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_select = _resolveComponent("a-select");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("span", null, "国家/地区", 512), [[_vShow, !searchMode.value]]), _withDirectives(_createVNode(_component_a_input, {
        class: "littleInputer",
        size: "small",
        value: searchName.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => searchName.value = $event),
        onChange: searcher
      }, null, 8, ["value"]), [[_vShow, searchMode.value]]), _createVNode(SvgIcon, {
        class: "optIcon",
        "icon-class": "search",
        onClick: _cache[1] || (_cache[1] = $event => searchMode.value = !searchMode.value)
      })]), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createVNode(_component_a_spin, {
        class: "spinBody",
        tip: "加载中..."
      }, null, 512), [[_vShow, queryPriceLoading.value || __props.loading]]), _withDirectives(_createElementVNode("div", null, _hoisted_8, 512), [[_vShow, !showData.value.length && !queryPriceLoading.value && !__props.loading]]), _withDirectives(_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showData.value, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: "item"
        }, [_createElementVNode("div", {
          class: _normalizeClass(['country', {
            editLine: item.prodPrice !== item.originProdPrice
          }])
        }, _toDisplayString(item.regionName), 3), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.prodPriceCurrency), 1), !item.editMode ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.prodPrice), 1)) : _createCommentVNode("", true), item.editMode ? (_openBlock(), _createBlock(_component_a_select, {
          key: 1,
          class: "selecter",
          value: item.prodPrice,
          "onUpdate:value": $event => item.prodPrice = $event,
          placholder: "请选择语言",
          style: {
            "width": "80px",
            "display": "inline-block"
          },
          size: "small",
          options: item.price,
          "field-names": {
            label: 'prodPrice',
            value: 'prodPrice'
          }
        }, null, 8, ["value", "onUpdate:value", "options"])) : _createCommentVNode("", true), !props.disabled ? (_openBlock(), _createElementBlock("div", _hoisted_12, [!item.editMode ? (_openBlock(), _createBlock(SvgIcon, {
          key: 0,
          class: "optIcon edit",
          "icon-class": "edit",
          onClick: () => {
            item.editMode = !item.editMode;
            showEdit(i, item);
          }
        }, null, 8, ["onClick"])) : _createCommentVNode("", true), item.editMode ? (_openBlock(), _createBlock(SvgIcon, {
          key: 1,
          class: "optIcon",
          "icon-class": "confirm",
          onClick: $event => confirmChange(item, i)
        }, null, 8, ["onClick"])) : _createCommentVNode("", true), item.editMode ? (_openBlock(), _createBlock(SvgIcon, {
          key: 2,
          class: "optIcon close",
          "icon-class": "close",
          onClick: $event => cancelData(item)
        }, null, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]);
      }), 128))], 512), [[_vShow, !queryPriceLoading.value && showData.value.length && !__props.loading]])])])]), _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(prodChnlText)), 1)], 64);
    };
  }
});